import { dataHooks } from '@wix/data-hooks';

export const articleFooterDataHooks = dataHooks<{
  container;
}>('articleFooter');
